import {z} from 'zod'

export const PaginationModelSchema = z.object({
  page: z.number(),
  size: z.number(),
  totalElements: z.number(),
  totalPages: z.number(),
})

export function PageableResponseSchema<T extends z.ZodTypeAny>(contentItemSchema: T) {
  return z.object({
    content: z.array(contentItemSchema),
    pagination: PaginationModelSchema,
  })
}
